'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _firefox = require('./images/firefox.png');

var _firefox2 = _interopRequireDefault(_firefox);

var _chrome = require('./images/chrome.png');

var _chrome2 = _interopRequireDefault(_chrome);

var _iexplore = require('./images/iexplore.png');

var _iexplore2 = _interopRequireDefault(_iexplore);

var _safari = require('./images/safari.png');

var _safari2 = _interopRequireDefault(_safari);

var _opera = require('./images/opera.png');

var _opera2 = _interopRequireDefault(_opera);

var _maxthon = require('./images/maxthon.png');

var _maxthon2 = _interopRequireDefault(_maxthon);

var _netscape = require('./images/netscape.png');

var _netscape2 = _interopRequireDefault(_netscape);

var _flock = require('./images/flock.png');

var _flock2 = _interopRequireDefault(_flock);

var _Image = require('../Image/Image');

var _Image2 = _interopRequireDefault(_Image);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var available = {
  firefox: { name: 'Firefox', icon: _firefox2.default },
  chrome: { name: 'Chrome', icon: _chrome2.default },
  iexplore: { name: 'Internet explorer', icon: _iexplore2.default },
  safari: { name: 'Safari', icon: _safari2.default },
  opera: { name: 'Opera', icon: _opera2.default },
  maxthon: { name: 'maxthon', icon: _maxthon2.default },
  netscape: { name: 'Netscape', icon: _netscape2.default },
  flock: { name: 'Flock', icon: _flock2.default }
};

var Browser = function (_Component) {
  _inherits(Browser, _Component);

  function Browser() {
    _classCallCheck(this, Browser);

    return _possibleConstructorReturn(this, (Browser.__proto__ || Object.getPrototypeOf(Browser)).apply(this, arguments));
  }

  _createClass(Browser, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          vendor = _props.vendor,
          version = _props.version,
          showText = _props.showText;

      return _react2.default.createElement(
        'div',
        { className: 'd-inline Browser' },
        _react2.default.createElement(_Image2.default, {
          src: available[vendor].icon,
          alt: 'Browser ' + available[vendor].name + ' icon',
          className: 'Browser__Icon'
        }),
        showText && _react2.default.createElement(
          'div',
          { className: 'Browser__Text' },
          ' ',
          available[vendor].name
        ),
        version && _react2.default.createElement(
          'div',
          { className: 'Browser__Version' },
          version
        )
      );
    }
  }]);

  return Browser;
}(_react.Component);

Browser.propTypes = {
  showText: _propTypes2.default.bool,
  vendor: _propTypes2.default.string,
  version: _propTypes2.default.string
};
Browser.defaultProps = {
  showText: true,
  vendor: '',
  version: ''
};

exports.default = Browser;